import { Star, Quote } from "lucide-react";
import { reviews } from "../data/menuData";

function Stars({ count }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={16}
          fill={i <= count ? "#FFB800" : "transparent"}
          color="#FFB800"
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="bg-[#FAFAFA] border-b-2 border-black"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-6">
            <div className="inline-block brutal-border bg-[#D92525] text-white px-3 py-1 text-xs font-bold uppercase tracking-widest mb-4">
              Customer Love
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] text-black">
              What our <span className="text-[#D92525]">customers</span>
              <br /> are saying.
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <div className="brutal-border brutal-shadow bg-[#FFB800] p-6 w-full">
              <div className="flex items-center gap-4">
                <div className="font-display text-6xl md:text-7xl text-black leading-none">
                  4.1
                </div>
                <div className="leading-tight">
                  <Stars count={4} />
                  <div className="font-body text-sm font-semibold text-black mt-1">
                    out of 5 stars
                  </div>
                  <div className="font-body text-xs text-neutral-800">
                    Based on real customer feedback
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((r, idx) => (
            <div
              key={r.name}
              data-testid={`review-card-${idx}`}
              className="brutal-border brutal-shadow bg-white p-6 flex flex-col gap-4"
            >
              <Quote
                size={28}
                strokeWidth={2.5}
                className="text-[#D92525]"
              />
              <p className="font-body text-base text-neutral-900 leading-relaxed flex-1">
                "{r.text}"
              </p>
              <div className="flex items-center justify-between pt-4 border-t-2 border-black">
                <div>
                  <div className="font-display text-xl uppercase text-black leading-tight">
                    {r.name}
                  </div>
                  <div className="text-xs text-neutral-600 uppercase tracking-widest">
                    {r.role}
                  </div>
                </div>
                <Stars count={r.rating} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
